import styled from 'styled-components';
import { rem } from 'polished';

export const StyledLoader = styled.div`
  align-self: center;
  padding: ${rem(32)};
`;
